import "@turf/turf";
import "./index.es175.js";
import { rgbArrayToHex as t } from "./index.es277.js";
import "./index.es176.js";
import { DEFAULT_COLOR_SEQUENTIAL_PALETTE_COLORS as e } from "./index.es59.js";
const m = {
  timeSelected: [5]
}, p = {
  palette: e[2],
  opacity: 30,
  stroke: 3,
  inEditMode: !0,
  includeLayer: !0,
  legendTitle: "Walk Time",
  items: [
    {
      color: t(e[2].paletteColors[0]),
      value: "5",
      visible: !0
    }
  ]
};
export {
  m as walkTimeDefaultFetchFilter,
  p as walkTimeDefaultVisualFilter
};
//# sourceMappingURL=index.es86.js.map
